import { COVERGO_SAAS_DEV, COVERGO_ASIA_DR } from "../consts.js"

export const chdr_dev = {
	"chdr-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "chdr_dev",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_DEV,
		fileSystem: {
			bucketName: "covergo-apse1-dev-chdr-dev"
		}
	}
}
export const chdr_dr = {	
	"chdr-studio.dr.asia.covergo.cloud": {
		appConfig: {
			tenantId: "chdr_dr",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_ASIA_DR,
		fileSystem: {
			bucketName: "covergo-apse1-dr-chdr-dr"
		}
	}
}


